import { gql } from '@apollo/client'

export const CHANNELS_QUERY = gql`
  query Channels($propertiesCode: [String], $showLog: Boolean) {
    channels(propertiesCode: $propertiesCode, showLog: $showLog) {
      basicDetails {
        name
        channelCode
        displayChannelCode
        channelType
        channelID
      }
    }
  }
`

export const CHANNEL_QUERY = gql`
  query Channel($channelId: String, $channelCode: String) {
    channel(channelId: $channelId, channelCode: $channelCode) {
      basicDetails {
        name
        name2
        channelCode
        displayChannelCode
        IATA
        channelType
        currency
        channelID
        shortName
        shortNameTranslatedList {
          label
          nativeLabel
          value
        }
        showProviderName
      }
    }
  }
`

export const CHANNEL_NAME_QUERY = gql`
  query ChannelName($channelId: String, $channelCode: String) {
    channelName(channelId: $channelId, channelCode: $channelCode) {
      basicDetails {
        name
        name2
        channelCode
        displayChannelCode
        channelID
      }
    }
  }
`

export const CHANNELS_WITH_LOGO_QUERY = gql`
  query ChannelsWithLogo {
    channelsWithLogo {
      basicDetails {
        name
        channelCode
        displayChannelCode
        channelType
        channelID
      }
      Logo {
        url
        size
        name
      }
    }
  }
`

export const CHANNEL_GENERATE_MUTATION = gql`
  mutation GenerateChannel($input: ChannelInput!) {
    generateChannel(input: $input) {
      message
    }
  }
`
export const CHANNEL_MODIFY_MUTATION = gql`
  mutation ModifyChannel($input: ChannelInput!, $channelCode: String!) {
    modifyChannel(input: $input, channelCode: $channelCode) {
      message
    }
  }
`
